// Playbook Library status filter pills — FE-044.

import type { PlaybookStatusFilter } from "./types";


const FILTER_OPTIONS: Array<{ key: PlaybookStatusFilter; label: string }> = [
  { key: "all", label: "All" },
  { key: "system", label: "System" },
  { key: "custom", label: "Custom" },
  { key: "archived", label: "Archived" },
];


export interface PlaybookListFiltersProps {
  status: PlaybookStatusFilter;
  onChange: (next: PlaybookStatusFilter) => void;
}


export function PlaybookListFilters({
  status, onChange,
}: PlaybookListFiltersProps) {
  return (
    <div
      data-testid="playbook-list-filters"
      role="tablist"
      aria-label="Playbook status filter"
      className="inline-flex items-center gap-1 rounded-md bg-recessed p-1"
    >
      {FILTER_OPTIONS.map((opt) => {
        const active = opt.key === status;
        return (
          <button
            key={opt.key}
            type="button"
            role="tab"
            aria-selected={active}
            data-testid={`playbook-filter-${opt.key}`}
            onClick={() => onChange(opt.key)}
            className={[
              "rounded px-2.5 py-1 text-xs transition-fast ease-out",
              active
                ? "bg-canvas font-medium text-text-primary shadow-sm"
                : "text-text-secondary hover:text-text-primary",
            ].join(" ")}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
